export default class KeyNamePair{
  private _key: string;
  private _name: string;
  
  constructor(key: string, name: string) {
    this._key = key;
    this._name = name;
  }
  public get key(): string {
    return this._key;
  }
  public get name(): string {
    return this._name;
  }
}